import React from "react";

function Book() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4751 4.24023C21.6782 4.24023 22.6665 5.18555 22.6665 6.30273V17.3027C22.6665 18.4629 21.6782 19.3652 20.4751 19.3652H3.4165C1.86963 19.3652 0.666504 18.1621 0.666504 16.6152V2.86523C0.666504 1.36133 1.86963 0.115234 3.4165 0.115234H19.229C20.3462 0.115234 21.2915 1.06055 21.2915 2.17773C21.2915 2.56445 20.9478 2.86523 20.604 2.86523H4.104C3.71729 2.86523 3.4165 3.20898 3.4165 3.55273C3.4165 3.93945 3.71729 4.24023 4.104 4.24023H20.4751ZM18.5415 13.1777C19.272 13.1777 19.9165 12.5762 19.9165 11.8027C19.9165 11.0723 19.272 10.4277 18.5415 10.4277C17.7681 10.4277 17.1665 11.0723 17.1665 11.8027C17.1665 12.5762 17.7681 13.1777 18.5415 13.1777Z"
        fill="#0A0624"
      />
    </svg>
  );
}

export default Book;
